import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { PrinterIcon, CalendarIcon, SearchIcon, ReceiptIcon } from 'lucide-react';
interface DetentionRecord {
  id: string;
  gatePassNo: string;
  vehicleNo: string;
  vehicleType: string;
  entryDate: string;
  entryFee: number;
  parkingFee: number;
  noOfDays: number;
}
const mockData: DetentionRecord[] = [{
  id: '1',
  gatePassNo: 'GP-2026-0001',
  vehicleNo: 'MH-12-AB-1234',
  vehicleType: 'Truck',
  entryDate: '10/04/26 08:30',
  entryFee: 150,
  parkingFee: 1000,
  noOfDays: 5
}, {
  id: '2',
  gatePassNo: 'GP-2026-0002',
  vehicleNo: 'MH-14-CD-5678',
  vehicleType: 'Car',
  entryDate: '12/04/26 09:15',
  entryFee: 50,
  parkingFee: 300,
  noOfDays: 3
}, {
  id: '3',
  gatePassNo: 'GP-2026-0003',
  vehicleNo: 'GJ-05-EF-9012',
  vehicleType: 'Van',
  entryDate: '13/04/26 09:45',
  entryFee: 100,
  parkingFee: 300,
  noOfDays: 2
}, {
  id: '4',
  gatePassNo: 'GP-2026-0004',
  vehicleNo: 'DL-01-GH-3456',
  vehicleType: 'Trailer',
  entryDate: '08/04/26 10:00',
  entryFee: 200,
  parkingFee: 1750,
  noOfDays: 7
}, {
  id: '5',
  gatePassNo: 'GP-2026-0005',
  vehicleNo: 'RJ-14-IJ-7890',
  vehicleType: 'Truck',
  entryDate: '14/04/26 10:30',
  entryFee: 150,
  parkingFee: 200,
  noOfDays: 1
}, {
  id: '6',
  gatePassNo: 'GP-2026-0006',
  vehicleNo: 'KA-01-KL-2345',
  vehicleType: 'Car',
  entryDate: '11/04/26 11:00',
  entryFee: 50,
  parkingFee: 400,
  noOfDays: 4
}, {
  id: '7',
  gatePassNo: 'GP-2026-0007',
  vehicleNo: 'TN-09-MN-6789',
  vehicleType: 'Bike',
  entryDate: '15/04/26 11:20',
  entryFee: 20,
  parkingFee: 50,
  noOfDays: 0
}, {
  id: '8',
  gatePassNo: 'GP-2026-0008',
  vehicleNo: 'UP-32-OP-0123',
  vehicleType: 'Truck',
  entryDate: '05/04/26 11:45',
  entryFee: 150,
  parkingFee: 2000,
  noOfDays: 10
}, {
  id: '9',
  gatePassNo: 'GP-2026-0009',
  vehicleNo: 'MP-09-QR-4567',
  vehicleType: 'Van',
  entryDate: '14/04/26 12:10',
  entryFee: 100,
  parkingFee: 150,
  noOfDays: 1
}, {
  id: '10',
  gatePassNo: 'GP-2026-0010',
  vehicleNo: 'HR-26-ST-8901',
  vehicleType: 'Trailer',
  entryDate: '12/04/26 12:30',
  entryFee: 200,
  parkingFee: 750,
  noOfDays: 3
}];
export function POSVehicleDetentionPage() {
  const [startDate, setStartDate] = useState('2026-04-01');
  const [endDate, setEndDate] = useState('2026-04-15');
  const [hasGenerated, setHasGenerated] = useState(false);
  const totalEntryFee = mockData.reduce((s, r) => s + r.entryFee, 0);
  const totalParkingFee = mockData.reduce((s, r) => s + r.parkingFee, 0);
  const handleGenerate = () => {
    setHasGenerated(true);
  };
  const handlePrint = () => {
    document.body.classList.add('print-thermal');
    window.print();
    document.body.classList.remove('print-thermal');
  };
  return <div className="w-full max-w-6xl mx-auto" data-id="element-1189">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="bg-white rounded-2xl shadow-xl shadow-slate-200/50 border border-slate-100 p-5 xs:p-6 sm:p-8 no-print" data-id="element-1190">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6" data-id="element-1191">
          <div className="flex items-center gap-3" data-id="element-1192">
            <div className="bg-brand-teal/10 p-2 rounded-xl border border-brand-teal/20" data-id="element-1193">
              <ReceiptIcon className="w-6 h-6 text-brand-teal" data-id="element-1194" />
            </div>
            <div data-id="element-1195">
              <h2 className="text-xl sm:text-2xl font-bold text-slate-900 tracking-tight" data-id="element-1196">
                POS Vehicle Detention
              </h2>
              <p className="text-sm text-slate-500" data-id="element-1197">
                Thermal print format for detained vehicle records.
              </p>
            </div>
          </div>
          {hasGenerated && <button onClick={handlePrint} className="inline-flex items-center justify-center gap-2 bg-brand-teal text-white px-4 py-2.5 rounded-xl font-medium text-sm hover:bg-brand-tealHover transition-colors" data-id="element-1198">
              <PrinterIcon className="w-4 h-4" data-id="element-1199" />
              Print (80mm)
            </button>}
        </div>

        {/* Filters */}
        <div className="flex flex-col sm:flex-row gap-4 mb-8 p-4 bg-slate-50 rounded-xl border border-slate-200" data-id="element-1200">
          <div className="flex-1" data-id="element-1201">
            <label className="block text-xs font-semibold text-slate-500 mb-1.5" data-id="element-1202">
              Start Date
            </label>
            <div className="relative" data-id="element-1203">
              <CalendarIcon className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4.5 h-4.5 text-slate-400 pointer-events-none" data-id="element-1204" />
              <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} className="w-full pl-10 pr-4 py-2.5 rounded-xl border border-slate-200 bg-white text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-brand-teal/30 focus:border-brand-teal transition-all" data-id="element-1205" />
            </div>
          </div>
          <div className="flex-1" data-id="element-1206">
            <label className="block text-xs font-semibold text-slate-500 mb-1.5" data-id="element-1207">
              End Date
            </label>
            <div className="relative" data-id="element-1208">
              <CalendarIcon className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4.5 h-4.5 text-slate-400 pointer-events-none" data-id="element-1209" />
              <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} className="w-full pl-10 pr-4 py-2.5 rounded-xl border border-slate-200 bg-white text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-brand-teal/30 focus:border-brand-teal transition-all" data-id="element-1210" />
            </div>
          </div>
          <div className="flex items-end" data-id="element-1211">
            <button onClick={handleGenerate} className="w-full sm:w-auto px-6 py-2.5 bg-slate-800 text-white rounded-xl font-medium text-sm hover:bg-slate-700 transition-colors flex items-center justify-center gap-2 h-[42px]" data-id="element-1212">
              <SearchIcon className="w-4 h-4" data-id="element-1213" />
              Generate
            </button>
          </div>
        </div>

        {/* Screen Data Table */}
        {hasGenerated && <div className="border border-slate-200 rounded-xl overflow-hidden" data-id="element-1214">
            <div className="overflow-x-auto" data-id="element-1215">
              <table className="w-full text-left text-sm whitespace-nowrap" data-id="element-1216">
                <thead className="bg-slate-50 border-b border-slate-200 text-slate-500" data-id="element-1217">
                  <tr data-id="element-1218">
                    <th className="px-4 py-3 font-semibold" data-id="element-1219">Gate Pass No.</th>
                    <th className="px-4 py-3 font-semibold" data-id="element-1220">Vehicle No.</th>
                    <th className="px-4 py-3 font-semibold" data-id="element-1221">Type</th>
                    <th className="px-4 py-3 font-semibold" data-id="element-1222">Entry Date</th>
                    <th className="px-4 py-3 font-semibold text-right" data-id="element-1223">
                      Entry Fee (₹)
                    </th>
                    <th className="px-4 py-3 font-semibold text-right" data-id="element-1224">
                      Parking Fee (₹)
                    </th>
                    <th className="px-4 py-3 font-semibold text-center" data-id="element-1225">
                      Days
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100" data-id="element-1226">
                  {mockData.map(row => <tr key={row.id} className="hover:bg-slate-50/50 transition-colors" data-id="element-1227">
                      <td className="px-4 py-3 font-mono text-slate-700 font-medium" data-id="element-1228">
                        {row.gatePassNo}
                      </td>
                      <td className="px-4 py-3 font-mono text-slate-900 font-bold" data-id="element-1229">
                        {row.vehicleNo}
                      </td>
                      <td className="px-4 py-3 text-slate-600" data-id="element-1230">
                        {row.vehicleType}
                      </td>
                      <td className="px-4 py-3 text-slate-600" data-id="element-1231">
                        {row.entryDate}
                      </td>
                      <td className="px-4 py-3 text-right text-slate-700" data-id="element-1232">
                        {row.entryFee.toFixed(2)}
                      </td>
                      <td className="px-4 py-3 text-right text-slate-700" data-id="element-1233">
                        {row.parkingFee.toFixed(2)}
                      </td>
                      <td className="px-4 py-3 text-center" data-id="element-1234">
                        <span className="inline-flex items-center justify-center min-w-[24px] h-6 px-1.5 rounded-md bg-slate-100 text-slate-700 text-xs font-semibold" data-id="element-1235">
                          {row.noOfDays}
                        </span>
                      </td>
                    </tr>)}
                </tbody>
                <tfoot className="bg-slate-50 border-t border-slate-200 font-bold text-slate-900" data-id="element-1236">
                  <tr data-id="element-1237">
                    <td colSpan={4} className="px-4 py-3 text-right" data-id="element-1238">
                      Total:
                    </td>
                    <td className="px-4 py-3 text-right text-brand-teal" data-id="element-1239">
                      ₹{totalEntryFee.toFixed(2)}
                    </td>
                    <td className="px-4 py-3 text-right text-brand-teal" data-id="element-1240">
                      ₹{totalParkingFee.toFixed(2)}
                    </td>
                    <td className="px-4 py-3" data-id="element-1241"></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>}
      </motion.div>

      {/* 80mm Thermal Print Layout */}
      {hasGenerated && <div id="print-receipt" className="hidden print:block bg-white font-mono text-[11px] leading-[1.4] text-black p-4 w-[302px] print:w-[80mm] print:p-[4mm]" data-id="element-1242">
          {/* Header */}
          <div className="text-center mb-1" data-id="element-1243">
            <div className="text-[15px] font-bold tracking-wide" data-id="element-1244">
              ERPLogiPark
            </div>
            <div className="text-[9px] leading-tight mt-0.5 text-gray-700" data-id="element-1245">
              Terminal Management &amp; Gate Automation
            </div>
          </div>
          <div className="text-center text-[9px] leading-tight text-gray-600 mb-2" data-id="element-1246">
            Plot No. 45, Logistics Hub, Sector 18
            <br data-id="element-1247" />
            Industrial Area, Bangalore - 560100
          </div>

          <div className="border-t border-dashed border-gray-400 my-2" data-id="element-1248" />

          <div className="text-center font-bold text-[12px] tracking-wider mb-1" data-id="element-1249">
            VEHICLE DETENTION REPORT
          </div>
          <div className="text-center text-[9px] text-gray-600 mb-1" data-id="element-1250">
            {startDate} to {endDate}
          </div>

          <div className="border-t border-dashed border-gray-400 my-2" data-id="element-1251" />

          {/* Records */}
          <div className="space-y-2" data-id="element-1252">
            {mockData.map((row, idx) => <div key={row.id} data-id="element-1253">
                <div className="flex justify-between text-[10px]" data-id="element-1254">
                  <span className="font-bold" data-id="element-1255">
                    {idx + 1}. {row.gatePassNo}
                  </span>
                  <span data-id="element-1256">{row.noOfDays}d</span>
                </div>
                <div className="flex justify-between text-[10px]" data-id="element-1257">
                  <span className="font-bold" data-id="element-1258">{row.vehicleNo}</span>
                  <span className="text-gray-500" data-id="element-1259">{row.vehicleType}</span>
                </div>
                <div className="text-[9px] text-gray-500" data-id="element-1260">{row.entryDate}</div>
                <div className="flex justify-between text-[10px] mt-0.5" data-id="element-1261">
                  <span data-id="element-1262">Entry: ₹{row.entryFee}</span>
                  <span data-id="element-1263">Parking: ₹{row.parkingFee}</span>
                </div>
                {idx < mockData.length - 1 && <div className="border-t border-dotted border-gray-300 mt-1.5" data-id="element-1264" />}
              </div>)}
          </div>

          <div className="border-t border-dashed border-gray-400 my-2" data-id="element-1265" />

          {/* Totals */}
          <div className="space-y-[4px]" data-id="element-1266">
            <div className="flex justify-between text-[11px]" data-id="element-1267">
              <span data-id="element-1268">Total Vehicles:</span>
              <span className="font-bold" data-id="element-1269">{mockData.length}</span>
            </div>
            <div className="flex justify-between text-[11px]" data-id="element-1270">
              <span data-id="element-1271">Total Entry Fee:</span>
              <span className="font-bold" data-id="element-1272">₹{totalEntryFee.toFixed(2)}</span>
            </div>
            <div className="flex justify-between text-[11px]" data-id="element-1273">
              <span data-id="element-1274">Total Parking Fee:</span>
              <span className="font-bold" data-id="element-1275">₹{totalParkingFee.toFixed(2)}</span>
            </div>
            <div className="border-t border-dotted border-gray-300 my-1" data-id="element-1276" />
            <div className="flex justify-between font-bold text-[13px]" data-id="element-1277">
              <span data-id="element-1278">GRAND TOTAL:</span>
              <span data-id="element-1279">₹{(totalEntryFee + totalParkingFee).toFixed(2)}</span>
            </div>
          </div>

          <div className="border-t border-dashed border-gray-400 my-3" data-id="element-1280" />

          {/* Footer */}
          <div className="text-center text-[8px] text-gray-500 leading-tight" data-id="element-1281">
            <div data-id="element-1282">Generated: {new Date().toLocaleString()}</div>
            <div data-id="element-1283">This is a computer generated report.</div>
            <div className="mt-1" data-id="element-1284">© 2026 ERPLogiPark</div>
          </div>
        </div>}
    </div>;
}